<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

const { locale } = await useInitApp()
</script>

<template>
  <UApp :locale="locale">
    <ApplicationHeaderNavigation />
    <UMain>
      <UError :error="props.error" />
    </UMain>
  </UApp>
</template>
